import { render } from "./TeamResults2.vue?vue&type=template&id=f4975bb6"
import script from "./TeamResults2.vue?vue&type=script&lang=js"
export * from "./TeamResults2.vue?vue&type=script&lang=js"

import "./TeamResults2.vue?vue&type=style&index=0&id=f4975bb6&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__